<div class="countries-container">
  <div class="country-search-container" [ngClass]="{ 'searchContainerFocus' : searchFocus === true }">
    <nb-icon class="search-icon" icon="search" pack="icomoon"></nb-icon>
    <input
      type="text"
      name="country"
      [disabled]="campaignCountryList.length === 0 && loading"
      placeholder="{{ 'view_translations.search' | translate }}"
      (focus)="searchFocus = true"
      (blur)="searchFocus = false"
      tabindex="-1"
      [ngModel]="searchVal | async"
      (ngModelChange)="searchValHandler($event)" />
    <div class="clear-wrapper" (click)="clearInput()" *ngIf="(searchValue?.length ?? 0 ) > 0">
      <nb-icon icon="basket-filled" pack="icomoon" class="icon"></nb-icon>
    </div>
  </div>
  <div class="header-outer" *ngIf="campaignCountryList.length && !loading">
    <app-scrollable-tab-menu (getActiveMenuItem)="scroll($event)" [menuItems]="tabMenuItems"></app-scrollable-tab-menu>
  </div>
  <div class="all-countries" id="allCountriesGroup" #countriesList>
    <ng-container *ngIf="campaignCountryList.length && !loading">
      <div *ngFor="let item of countryList | keyvalue" class="countries-group" id="{{ 'letter_' + item.key }}">
        <div class="countries-group-inner-container">
          <div class="countries-group-header">
            <h1>{{item.key}}</h1>
            <div class="countries-counter">
              <span>{{ item.value.countries.length }}</span>
            </div>
          </div>
          <ul class="countries-list">
            <li
              class="single-country"
              *ngFor="let country of item.value.countries; trackBy: trackCountry"
              [ngClass]="{'inactive': watchInactiveCountries && !country.active, 'pointer': watchInactiveCountries}"
              (click)="onCountryClickHandler(!country.active,country.id)">
              <div class="img-container">
                <img
                  class="flag-icon"
                  src="{{ 'assets/icons/flags/' + country.code.toLowerCase() + '.png' }}"
                  alt="{{ ('countries.' + (country.id - 1)  | translate).name }}" />
              </div>
              <h3>{{ ('countries.' + (country.id - 1) | translate).name }}</h3>
            </li>
          </ul>
        </div>
      </div></ng-container
    >
  </div>
  <app-loader *ngIf="loading"></app-loader>
  <div class="results-not-found" *ngIf="campaignCountryList.length === 0 && !loading">
    <h4>{{ 'view_translations.no_results' | translate }}</h4>
  </div>
</div>
